import i18next from "i18next";
import React from "react";
import ReactDOM from "react-dom";
import { I18nextProvider } from "react-i18next";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import "./index.css";
import "./fonts/TextWatermarkFonts/fonts.css";
import store from "./Redux/store";

//Translations
import common_en from "./Translation/en/common.json";
import common_ru from "./Translation/zh/common.json";
import { PersistGate } from "redux-persist/integration/react";
import persistStore from "redux-persist/es/persistStore";

i18next.init({
  ns: ["common", "translation"],
  defaultNS: "common",
  supportedLngs: ["en", "zh"],
  fallbackLng: "en",
  interpolation: { escapeValue: false }, // React already does escaping
  resources: {
    en: {
      common: common_en, // 'common' is our custom namespace
    },
    zh: {
      common: common_ru, // 'common' is our custom namespace
    },
  },
  lng: "en", // language to use
  // localStorage.getItem("language") === "" ||
  // localStorage.getItem("language") === null
  //   ? navigator.language
  //   : localStorage.getItem("language")
});

const persistor = persistStore(store);

if (typeof module !== "undefined" && module.hot) {
  module.hot.accept();
}

const root = document.getElementById("root");
if (!root) throw new Error("Root element not found");

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <I18nextProvider i18n={i18next}>
          <Router>
            <App />
          </Router>
        </I18nextProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  root
);
